import * as React from "react";
import { DotLoadingIndicator } from "@xingternal/dot-loading-indicator";
import { ZenView } from "@xingternal/platform-layout-zen";
import XingView from "@xingternal/xing-view";
import LoggedoutView from "@xingternal/xing-view/LoggedoutView";
import { Wrapper } from "./layout-switcher.styles";
const LayoutSwitcher = ({
  loadingMainQuery,
  layout,
  children,
  loginState
}) => {
  if (loadingMainQuery) {
    return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(DotLoadingIndicator, null));
  }
  if (!loginState.isLoggedIn) {
    return /* @__PURE__ */ React.createElement(LoggedoutView, {
      type: "standard"
    }, children);
  }
  switch (layout) {
    case "zen":
      return /* @__PURE__ */ React.createElement(ZenView, {
        withSubNav: true,
        testId: "crate-zen-view"
      }, children);
    case "xing":
    default:
      return /* @__PURE__ */ React.createElement(XingView, {
        withSubNav: true,
        testId: "crate-layout-main"
      }, children);
  }
};
export {
  LayoutSwitcher
};
